<template>
  <div class="form-wrapper">
    <div class="form float-right">
      <h3 class="form__title">
        <span class="title">登录</span>
        <span>(内测)</span>
      </h3>
      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group id="example-input-group-1">
          <b-form-input
            name="mobile"
            v-model="form.mobile"
            v-validate="'required|mobile'"
            :state="validateState('mobile')"
            aria-describedby="input-1-live-feedback"
            data-vv-as="手机号"
            placeholder="请输入您的手机号"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">{{ veeErrors.first('mobile') }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-2">
          <b-form-input
            :type="type"
            name="password"
            v-model="form.password"
            v-validate="'required|password'"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
            data-vv-as="密码"
            placeholder="请输入您的密码"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">{{ veeErrors.first('password') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-3">
          <b-form-input
            name="img_captcha"
            v-model="form.img_captcha"
            v-validate="'required|alpha_num'"
            :state="validateState('img_captcha')"
            aria-describedby="input-3-live-feedback"
            data-vv-as="验证码"
            placeholder="请输入验证码"
          ></b-form-input>

          <b-form-invalid-feedback id="input-3-live-feedback">{{ veeErrors.first('img_captcha') }}
          </b-form-invalid-feedback>
          <span class="img-captcha">
            <img class="img-captcha__img" :src="imgSrc" width="80" height="34" alt="图形验证码"
                 @click="handleRefreshCaptcha">
          </span>
        </b-form-group>
        <div class="status-area">
          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
          >
            记住登录状态
          </b-form-checkbox>
          <a href="forget_pwd.html" class="btn-forget float-right">忘记密码</a>
        </div>
        <b-button type="submit" variant="primary">确认</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
  import {messages} from 'common/js/validator'
  import service from 'common/js/service'
  import SparkMD5 from 'spark-md5'

  export default {
    name: "Form",
    data() {
      return {
        type: 'password',
        form: {
          mobile: null,
          password: null,
          img_captcha: null
        },
        status: false,
        isError: false,
        imgSrc: process.env.API_HOST + "/loginCode"
      }
    },
    created() {
      // 如果token存在，直接跳转到个人列表页
      let token = localStorage.getItem('token')

      if (token) {
        location.href = "my_file.html"
      }
    },
    mounted() {
      this.$validator.localize('zh_CN', messages)
    },
    methods: {
      // 验证表单
      validateState(ref) {
        if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
        ) {
          return !this.veeErrors.has(ref)
        }
        return null
      },
      // 重置表单
      resetForm() {
        this.form = {
          name: null,
          food: null
        }

        this.$nextTick(() => {
          this.$validator.reset()
        })
      },
      // 提交表单
      onSubmit() {
        this.$validator.errors.clear()
        this.$validator.validateAll().then(result => {
          let params = {
            loginName: this.form.mobile,
            passWord: SparkMD5.hash(this.form.password),
            yz: this.form.img_captcha
          }
          if (!result) {
            return
          }
          service.post(process.env.API_HOST + '/systoken', params)
            .then(this.getLoginSucc)
            .catch(error => {
              console.log(error)
            })
        })
      },
      getLoginSucc(res) {
        res = res.data
        if (res.code === 0 && res.data) {
          const data = res.data

          localStorage.setItem('userInfo', JSON.stringify(data)) // 将登录信息储存到localStorage中
          localStorage.setItem('token', data.token) // 将token存储到localStorage中
          location.href = "my_file.html"
        }
      },
      // 刷新图形验证码
      handleRefreshCaptcha() {
        this.imgSrc = process.env.API_HOST + "/loginCode?t=" + Math.random()
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~common/stylus/variables.styl'
  @import '~common/stylus/base.styl'

  .form >>> .custom-control-label
    color: $color-text-gray
    font-size: 14px

  .form >>> .custom-control-label:before
    border-radius: 0

  .form-group:last-of-type >>> .bv-no-focus-ring
    position: relative

    .form-control
      padding-right: 80px

      &.is-valid
        background-image: none

      &.is-invalid
        background-image: none

  .form-wrapper
    width: 1035px
    height: 696px
    margin: 50px auto 0
    background-image: url(../images/login_bg.png)

    .form
      width: 460px
      height: 675px
      padding: 103px 57px 136px
      margin-top: 10px

      &__title
        color: $color-text
        letter-spacing: 4px

        .title
          padding-top: 15px
          border-top: 4px solid $baseColor

      .form-control
        margin-top: 30px
        padding-left: 0
        padding-bottom: 15px
        border: none
        border-bottom: 1px solid #ddd
        border-radius: 0

        &:focus
          box-shadow: none

        &.is-invalid
          border-color: #dc3545

      .img-captcha
        position: absolute
        right: 0
        top: -8px

        img
          display: inline-block
          width: 80px
          height: 34px

      .status-area
        .custom-control
          display: inline-block

        .btn-forget
          text-decoration: underline

      .btn
        width: 148px
        height: 40px
        margin-top: 75px
        letter-spacing: 2px
        border-radius: 0
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Form.vue